// extracted by mini-css-extract-plugin
export default {"video-player":"Video--video-player--cbWW0","videoPlayer":"Video--video-player--cbWW0"};